/** Product catalog vocabulary. */

export const PRODUCT_KINDS = {
  sale: "sale",
  rental: "rental",
  bundle: "bundle",
} as const;

export type ProductKind = (typeof PRODUCT_KINDS)[keyof typeof PRODUCT_KINDS];

export const ALL_PRODUCT_KINDS: readonly ProductKind[] = [
  PRODUCT_KINDS.sale,
  PRODUCT_KINDS.rental,
  PRODUCT_KINDS.bundle,
];

export const PRODUCT_KIND_LABELS: Record<ProductKind, string> = {
  sale: "For sale",
  rental: "For rent",
  bundle: "Bundle",
};

/** Kinds whose own `stock` column is meaningful (bundles derive theirs). */
export const STOCKED_PRODUCT_KINDS: readonly ProductKind[] = [
  PRODUCT_KINDS.sale,
  PRODUCT_KINDS.rental,
];

export const PRODUCT_UNITS: readonly string[] = ["pcs", "set", "day", "box", "kg", "hour"];

export const DEFAULT_PRODUCT_UNIT = "pcs" as const;

export const PRODUCT_DEFAULTS = {
  maxNameLength: 120,
  maxDescriptionLength: 500,
  maxPrice: 9_999_999_999,
  maxStock: 999_999,
} as const;

export const VARIANT_DEFAULTS = {
  maxNameLength: 60,
  maxAttributes: 8,
} as const;

export const BUNDLE_DEFAULTS = {
  maxComponents: 20,
  maxComponentQuantity: 99,
  minComponents: 1,
} as const;
